import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahProviderSummary } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahProviderSummary, SahProviderSummaryRefreshResult } from '~support-at-home/models/sahProviderSummary';

// Covers the PRODA-sourced service-provider summary (registered service types + registration
// categories + the AC3 invoicing-mismatch warnings). Distinct from sahReferenceData.ts, which
// manages the global Services Australia reference lists rather than this company's own
// registration.
export const sahProviderSummaryApi = createApi({
  reducerPath: 'sahProviderSummaryApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahProviderSummary }),
  tagTypes: ['sahProviderSummary'],
  endpoints: (builder) => ({
    getSahProviderSummary: builder.query<SahProviderSummary, void>({
      query: () => ({ url: '', method: 'GET' }),
      transformResponse: (payload) => unwrap<SahProviderSummary>(payload),
      providesTags: [{ type: 'sahProviderSummary', id: 'LIST' }],
    }),
    // Invalidates the same tag as the status query: a refresh updates the stored summary and
    // registered service types, so the table must refetch to show the new sync state rather than
    // the stale pre-refresh snapshot.
    // Deliberately NOT `unwrap`ped, unlike the query above. A refresh whose write lost the
    // advisory-lock race still answers 200 / success: true, and the only signal that nothing was
    // persisted is the envelope's `message`. `unwrap` returns just `.data`, so the caller would
    // report a refresh that never landed.
    refreshSahProviderSummary: builder.mutation<SahProviderSummaryRefreshResult, void>({
      query: () => ({ url: '/refresh', method: 'POST' }),
      invalidatesTags: [{ type: 'sahProviderSummary', id: 'LIST' }],
    }),
  }),
});

export const { useGetSahProviderSummaryQuery, useRefreshSahProviderSummaryMutation } = sahProviderSummaryApi;
